<app-gallery-settings-customize-header
  title="Watermark"
  location="gallery-watermark-setting-item"
  (back)="back.emit()"
></app-gallery-settings-customize-header>
